import { render } from "./PaypalComponent.vue?vue&type=template&id=bab778e6"
import script from "./PaypalComponent.vue?vue&type=script&lang=js"
export * from "./PaypalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__